export default "__VITE_ASSET__FoU$LcOh__"